import React, { useState } from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { TreatmentCard } from '../components/treatments/TreatmentCard';
import { CtaBand } from '../components/ui/CtaBand';
import { SectionHeading } from '../components/ui/SectionHeading';
import { treatments, treatmentCategories } from '../data/treatments';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Treatments() {
  const [category, setCategory] = useState<string>('All');
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: `Treatments — ${brand.name}`,
    description: 'Hormonal and non-hormonal options for perimenopause and menopause, each listed with its real regulatory status and an honest read of the evidence.'
  });
  const filtered = category === 'All' ? treatments : treatments.filter(treatment => treatment.category === category);
  return <main className="w-full bg-cream" data-id="element-829" data-mp="2jzylo84f1lt2">
      <PageHeader eyebrow="Treatments" title="Every option, with its real status attached." intro="Hormonal and non-hormonal sit side by side here on purpose. If something is off-label, compounded, or thinly evidenced, it says so on the card — not in a footnote you have to hunt for." data-id="element-830" data-mp="2zi8x5ps5rnv7" />

      <section className="bg-cream" data-id="element-831" data-mp="34gsltxy4zdr9">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-10 md:px-8 md:pb-28 md:pt-14" data-id="element-832" data-mp="34jybbeaoghni">
          <div className="flex flex-wrap gap-2.5" role="group" aria-label="Filter treatments" data-id="element-833" data-mp="3ifsah5lnfsnf">
            {treatmentCategories.map(item => <button key={item} type="button" onClick={() => setCategory(item)} aria-pressed={category === item} className={`rounded-brand border px-5 py-2.5 text-sm transition-colors duration-150 ease-brand ${category === item ? 'border-brick bg-brick text-cream' : 'border-ink/20 text-ink-soft hover:border-ink/45 hover:text-ink'}`} data-id="element-834" data-mp="3s76dhnct7alb">
                {item}
              </button>)}
          </div>

          {filtered.length === 0 ? <p className="rule mt-12 pt-12 text-ink-soft" data-id="element-835" data-mp="32v8s0z68vtnb">
              Nothing in that category yet. Ask your clinician — if there is an evidence-based
              option we are not carrying, we want to know.
            </p> : <ul className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-836" data-mp="3co7kis4v44c7">
              {filtered.map(treatment => <li key={treatment.slug} className="flex" data-id="element-837" data-mp="3mkkapg178027">
                  <TreatmentCard treatment={treatment} data-id="element-838" data-mp="3ml2ces6mr6hi" />
                </li>)}
            </ul>}
        </div>
      </section>

      <section className="bg-cream-deep" data-id="element-839" data-mp="1s6rnykty6ec9">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-840" data-mp="1s7uid2qhaywx">
          <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-20" data-id="element-841" data-mp="1w8wehap3muuo">
            <SectionHeading eyebrow="How we prescribe" title="Non-hormonal options get equal shelf space." intro="Not every woman is a hormone therapy candidate, and not every woman who is wants to be. A site that only sells hormones will only ever find hormone-shaped answers." data-id="element-842" data-mp="1oovmd783gswr" />
            <ul className="flex flex-col" data-id="element-843" data-mp="1ay8kx7ay8owz">
              {['Nothing is prescribed without a clinician review of your full history.', 'Compounded and off-label products are labelled as such, every time.', 'We will tell you when the evidence for something is weak, including for things we could sell you.', 'Prices are held for twelve months. Titration does not trigger a surcharge.', 'You can have prescriptions sent to your own pharmacy instead of shipped.'].map(line => <li key={line} className="rule py-4 leading-relaxed text-ink first:border-t-0 first:pt-0" data-id="element-844" data-mp="i80da9e1hmwn">
                  {line}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand data-id="element-845" data-mp="2ax968nkfwbd1" />
    </main>;
}